import React from 'react'
import { Button } from 'antd'

const ModalFooter = ({
  currentStep,
  totalSteps,
  isStepValid,
  isValid,
  onPrev,
  onNext,
  onSubmit,
  onCancel
}) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
      <div>
        {currentStep > 0 && (
          <Button key="prev" onClick={onPrev}>
            Previous
          </Button>
        )}
      </div>
      <div style={{ display: 'flex', gap: '8px' }}>
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>
        {currentStep < totalSteps - 1 && (
          <Button
            key="next"
            type="primary"
            onClick={onNext}
            disabled={!isStepValid}
          >
            Next ({currentStep + 1}/{totalSteps})
          </Button>
        )}
        {currentStep === totalSteps - 1 && (
          <Button
            key="submit"
            type="primary"
            onClick={onSubmit}
            disabled={!isValid}
          >
            Submit
          </Button>
        )}
      </div>
    </div>
  )
}

export default ModalFooter
